<template>
    <v-row v-if="value">
        <v-col>
            <v-card :disabled="isCompany">
                <v-card-title class="subtitle-2 font-weight-bold">
                    상태정보
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col class="py-0 caption d-flex flex-column align-center">
                            <span>인테리어 신청</span>
                            <v-checkbox class="mt-0 py-0" hide-details readonly color="green" v-model="value.meta.interiorApplication"></v-checkbox>
                        </v-col>
                        <v-col class="py-0 caption d-flex flex-column align-center">
                            <span>인테리어 승인</span>
                            <v-switch class="mt-0 py-0" hide-details color="green" v-model="value.scope" value="interior" @change="$emit('saveScope')"></v-switch>
                        </v-col>
                        <v-col class="py-0 caption d-flex flex-column align-center">
                            <span>스토어 신청</span>
                            <v-checkbox class="mt-0 py-0" hide-details readonly color="green" v-model="value.meta.storeApplication"></v-checkbox>
                        </v-col>
                        <v-col class="py-0 caption d-flex flex-column align-center">
                            <span>스토어 승인</span>
                            <v-switch class="mt-0 py-0" hide-details color="green" v-model="value.scope" value="store" @change="$emit('saveScope')"></v-switch>
                        </v-col>
                        <v-col class="py-0 caption d-flex flex-column align-center">
                            <span>안심파트너 승인</span>
                            <v-switch class="mt-0 py-0" hide-details color="green" v-model="value.scope" value="reassurance" @change="$emit('saveScope')"></v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        value: Object,
    },

    computed: {
        isCompany() {
            return this.$store.state.payload._user == this.$route.params._user;
        },
    },
};
</script>

<style></style>
